"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.savePost = void 0;

var _constants = require("ComposeUI/lib/constants");

var _Categories = _interopRequireDefault(require("ContentUtils/constants/Categories"));

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _I18n = _interopRequireDefault(require("I18n"));

var _utils = require("ComposeUI/lib/utils");

var _PostManager = _interopRequireDefault(require("ComposeUI/data/PostManager"));

var postManager = new _PostManager.default();
var IS_EMPTY_TAG_REGEX = /^<[^><]+><\/\w+>$/i;
var MAX_SLUG_LENGTH = 170;

function defaultSavePostCallback(resp) {
  if (resp.processingStatus === _constants.ProcessingStatus.FORMATTING) {
    window.location.href = _Routes.default.edit(resp.id, _Categories.default.blog_post.field_name);
  }
}

function titleForSlugForTitle(contentGroup, postData) {
  if (contentGroup && contentGroup.slug) {
    return contentGroup.slug + "/" + postData.get('name');
  }

  return postData.get('name');
}

var handlePostErrors = function handlePostErrors() {
  _FloatingAlertStore.default.addAlert({
    message: _I18n.default.text('ComposeUI.errors.savePost.message'),
    titleText: _I18n.default.text('ComposeUI.errors.savePost.title'),
    type: 'danger'
  });
};

function parsePostForContent(post) {
  var parsedPost = (0, _utils.immutablePick)(post, _constants.ApiFields);

  var name = post.get('title') || _I18n.default.text('composer-lib.composer.temporaryTitle.blogPost');

  var id = post.get('originId');
  var rawPostBody = post.get('postBody');
  var postBody = IS_EMPTY_TAG_REGEX.test(rawPostBody) ? '' : rawPostBody;
  return parsedPost.merge({
    id: id,
    name: name,
    postBody: postBody
  });
}

function determineSavePromise(post, contentGroup) {
  var postToSend = parsePostForContent(post);

  if ([_I18n.default.text('composer-lib.composer.titlePlaceholder.blogPost'), _I18n.default.text('composer-lib.composer.temporaryTitle.blogPost')].includes(postToSend.get('name'))) {
    return postManager.savePost(postToSend.delete('name'), post.get('buffer'));
  }

  return postManager.fetchSlugForTitle({
    contentId: postToSend.get('id'),
    title: titleForSlugForTitle(contentGroup, postToSend)
  }).then(function (resp) {
    return postManager.savePost(postToSend.set('slug', resp.slug.slice(0, MAX_SLUG_LENGTH)), post.get('buffer'));
  });
}

var savePost = function savePost(post, contentGroup) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultSavePostCallback;
  return function () {
    determineSavePromise(post, contentGroup).then(callback, handlePostErrors);
  };
};

exports.savePost = savePost;